import {
  HTTP_GETFORECASTLIST3_FETCHING,
  HTTP_GETFORECASTLIST3_SUCCESS,
  HTTP_GETFORECASTLIST3_FAILED,
  HTTP_RESET_FORECASTLIST3,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";

export const setStateGetForecastToFetching3 = () => ({
  type: HTTP_GETFORECASTLIST3_FETCHING,
});

export const setStateGetForecastToSuccess3 = (payload) => ({
  type: HTTP_GETFORECASTLIST3_SUCCESS,
  payload,
});

export const setStateGetForecastToFailed3 = (payload) => ({
  type: HTTP_GETFORECASTLIST3_FAILED,
});

export const clearForecast3 = () => {
  return (dispatch) => {
    dispatch({ type: HTTP_RESET_FORECASTLIST3 });
  };
};
export const getForecast3 = (
  countryid,
  companyid,
  brandid,
  departmentid,
  yearcode,
  yearid
) => {
  return async (dispatch) => {
    dispatch(setStateGetForecastToFetching3());
    try {
      const result = await httpClient.get(
        `${server.GETFORECAST3_URL}/${countryid}/${companyid}/${brandid}/${departmentid}/${yearcode}/${yearid}`
      );

      dispatch(setStateGetForecastToSuccess3(result.data));

      return Promise.resolve(result.data.length);
    } catch (error) {
      dispatch(setStateGetForecastToFailed3());
      return Promise.reject(error.message);
    }
  };
};
